import yup from "src/utils/yup/extensionMethods";

const deleteSchema = (translate: Function) => yup.object().shape({
	efa004Descricao: yup.string().required(translate("Nome do grupo não confere")).oneOf([yup.ref("efa004DescricaoConfirmation")], translate("Nome do grupo não confere"))
});

const addAndChangeSchema = (translate: Function) => yup.object().shape({
	efa004Descricao: yup.string().required(translate("Descrição é requerida")),
	efa004Administrador: yup.boolean(),
	efa004Efa001Id: yup.string().nullable(),
	efa004Paginicial: yup.string().nullable()
});

export { deleteSchema, addAndChangeSchema };
